import type { AuthResponse, RegisterBody, RequestOtpResponse, UpdateProfileBody, UserDto } from '@zakat/shared';
import { http } from '@/lib/api';
import { queryClient, PERSONAL_QUERY_ROOTS } from '@/lib/query-client';
import { syncPushSubscription } from '@/lib/push';
import { useAuthStore } from '@/stores/auth';

export const authApi = {
  requestOtp: (identifier: { phone: string } | { email: string }) => http.post<RequestOtpResponse>('/auth/otp/request', identifier, { anonymous: true }),
  async verifyOtp(identifier: { phone: string } | { email: string }, code: string) {
    const res = await http.post<AuthResponse>('/auth/otp/verify', { ...identifier, code }, { anonymous: true });
    useAuthStore.getState().setSession(res.accessToken, res.user, res.expiresInSeconds);
    void syncPushSubscription();
    return res;
  },
  async pinLogin(phone: string, pin: string) {
    const res = await http.post<AuthResponse>('/auth/pin/login', { phone, pin }, { anonymous: true });
    useAuthStore.getState().setSession(res.accessToken, res.user, res.expiresInSeconds);
    void syncPushSubscription();
    return res;
  },
  async register(body: RegisterBody) {
    const res = await http.post<AuthResponse>('/auth/register', body, { anonymous: true });
    useAuthStore.getState().setSession(res.accessToken, res.user, res.expiresInSeconds);
    void syncPushSubscription();
    return res;
  },
  async setPin(pin: string, currentPin?: string) {
    await http.put('/me/pin', { pin, currentPin: currentPin || undefined });
    const user = useAuthStore.getState().user;
    if (user) useAuthStore.getState().setUser({ ...user, hasPin: true });
  },
  async logout() {
    await http.post('/auth/logout').catch(() => undefined);
    useAuthStore.getState().clear();
    for (const root of PERSONAL_QUERY_ROOTS) queryClient.removeQueries({ queryKey: [root] });
  },
  async updateProfile(body: UpdateProfileBody) {
    const user = await http.patch<UserDto>('/me', body);
    useAuthStore.getState().setUser(user);
    return user;
  },
  async uploadAvatar(file: File) {
    const form = new FormData();
    form.append('file', file);
    const user = await http.post<UserDto>('/me/avatar', form);
    useAuthStore.getState().setUser(user);
    return user;
  },
};
